import axios from "axios";
import { REACT_APP_DEV_BUILD, REACT_APP_ELASTIC_AUTH_TOKEN, REACT_APP_ELASTIC_URL } from "../constant/environment";
let index_name = ''
if (REACT_APP_DEV_BUILD === 'true'){
    index_name = 'test_woff'
}
else if(REACT_APP_DEV_BUILD === 'monotype'){
    index_name = 'monotype_com_font'
}
else{
    index_name = 'monotype_font'
}
const url = `${REACT_APP_ELASTIC_URL}/${index_name}/_msearch`;

const headers = {
    headers: {
      "content-type":"application/x-ndjson",
      "authorization" :`Basic ${REACT_APP_ELASTIC_AUTH_TOKEN}`
    }
}

const searchQuery = [
    {
        "preference":"results"
    }, 
    {
        "query": {
            "match_all":{}
        },
        "size": 10000,
    }
]

export const getFonts = async () => {
    let payload = "";
    for (const query of searchQuery) 
        payload += JSON.stringify(query) + "\n";
    const response = await axios.post(url, payload, headers)
    return response.data.responses[0].hits.hits;
}
export const getPairData = async () => {
    let payload = "";

    let url = `${REACT_APP_ELASTIC_URL}/${index_name}/_msearch`;
    for (const query of searchQuery) 
        payload += JSON.stringify(query) + "\n";
    const response = await axios.post(url, payload, headers)
    return response.data.responses[0].hits.hits;
}

